// extracted by mini-css-extract-plugin
export default {"heading":"help_heading__fd9xO","papercontainer":"help_papercontainer__9cHcw"};